import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as globals from '@reusable/services/globals';

@Injectable()
export class WalletCustomerService {
  handleError: any;
  responseData: any;
  constructor(private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}
  walletView() {
    return this.httpClient.get(`${globals.domain}/customer/wallets/view/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  walletWithdrow(body) {
    return this.httpClient.post(`${globals.domain}/customer/wallets/withdraw/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  refundWalletTransaction(walletTransactionId) {
    return this.httpClient
      .get(`${globals.domain}/customer/wallets-transactions/${walletTransactionId}/refund/`, this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
}